import styled from 'styled-components';

export const Comment = styled.div`
  & .ant-input-textarea-show-count::after {
    text-align: left;
  }
`;
